import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { editMember as editMemberService, savemembershippayment } from '../store/slices/userSlice';
import { useDispatch } from 'react-redux';
import { Button, Modal } from "react-bootstrap";

function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [subscriptionID, setSubscriptionID] = useState(null);
  const [transactionID, setTransactionID] = useState(null);
  const { userId, membershipType, amount, validupto } = location.state || {};
  const [countdown, setCountdown] = useState(5);
  const [paymentMethod, setPaymentMethod] = useState(null); // 'subscription' or 'one-time'

  console.log("Location state:", location.state);

  function unwrapResult(result) {
    try {
      if (result.payload) {
        return result.payload;
      } else if (result.error) {
        throw result.error;
      }
      return result;
    } catch (error) {
      console.error("Error unwrapping result:", error);
      throw error; // Re-throw after logging
    }
  }
  

  const handlePaymentSuccess = async (paymentId, isSubscription = true) => {
    if (isSubscription) {
      setSubscriptionID(paymentId);
    } else {
      setTransactionID(paymentId);
    }
    setStatus('success');

    try {
      // Dispatch savemembershippayment (if it's a thunk)
      await (savemembershippayment({
        member: userId,
        orderid: paymentId,
        paymentstatus: 'COMPLETED',
        amount: parseFloat(amount),
        paymentmode: 'Paypal',
        subscription: membershipType,
        date: new Date().toISOString().split('T')[0],
        status: 1
      }));

      const parts = validupto.split('-'); // e.g., ["01", "31", "2026"]
      const validUptoForBackend = `${parts[2]}-${parts[0]}-${parts[1]}`; // Result: "2026-01-31"

      const payload = {
        id: userId,
        subscriptionid: paymentId,
        status: 1,
        validupto: validUptoForBackend
      };

      // Dispatch editMemberService (if it's a thunk)
      const actionResult = await (editMemberService(payload));
      const response = unwrapResult(actionResult);

      if (response?.status === 200) {
        console.log("Member updated successfully after payment.");
      } else {
        console.error("Failed to update member record after payment:", response);
        setStatus('fail');
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      setStatus('fail');
    }
  };

  // Effect to load PayPal SDK based on paymentMethod
  // useEffect(() => {
  //   if (!paymentMethod) return; // Don't load until a method is chosen

  //   const scriptId = 'paypal-sdk-script';

  //   const loadPayPalScript = (intent) => {
  //     return new Promise((resolve, reject) => {
  //       let existingScript = document.getElementById(scriptId);
  //       if (existingScript) {
  //         existingScript.remove();
  //         delete window.paypal;
  //         console.log("Removed existing PayPal SDK script and cleared window.paypal.");
  //       }

  //       const script = document.createElement('script');
  //       script.id = scriptId;
  //       const scriptSrc = `https://www.paypal.com/sdk/js?client-id=AYB2yrW-VqMF7hAxqkXp4KZP-wLFomi24wBCLVQB3hna7V2mCdqZz4e4V3muCnlVw_6VcD4yhXQY0Rp8&vault=true&intent=${intent}`;
  //       script.src = scriptSrc;
  //       script.setAttribute('data-sdk-integration-source', 'button-factory');
  //       script.async = true;
  //       document.body.appendChild(script);

  //       script.onload = () => {
  //         const checkReady = setInterval(() => {
  //           if (window.paypal) {
  //             clearInterval(checkReady);
  //             console.log(`PayPal SDK loaded for intent: ${intent}.`);
  //             resolve();
  //           }
  //         }, 50);
  //       };

  //       script.onerror = (error) => {
  //         console.error("Failed to load PayPal SDK script:", error);
  //         reject(new Error("PayPal SDK script failed to load."));
  //       };
  //     });
  //   };

  //   const renderButtons = async () => {
  //     try {
  //       setLoading(true); // Set loading true before attempting to load/render
  //       if (paymentMethod === 'subscription') {
  //         await loadPayPalScript('subscription');
  //         const container = document.getElementById('paypal-button-container');
  //         if (container) {
  //           container.innerHTML = ''; // Clear previous buttons
  //           container.style.display = 'block'; // Show container
  //           window.paypal.Buttons({
  //             style: {
  //               shape: 'pill',
  //               color: 'gold',
  //               layout: 'vertical',
  //               label: 'subscribe',
  //             },
  //             createSubscription: function (data, actions) {
  //               return actions.subscription.create({
  //                 plan_id: 'P-0LK70549F8011274RNBOLFNA', // Your actual PayPal Plan ID
  //               });
  //             },
  //             onApprove: async function (data, actions) {
  //               if (data.subscriptionID) {
  //                 await handlePaymentSuccess(data.subscriptionID, true);
  //               } else {
  //                 setStatus('fail');
  //               }
  //             },
  //             onCancel: function () {
  //               setStatus('cancel');
  //               console.log("PayPal subscription cancelled.");
  //             },
  //             onError: function (err) {
  //               console.error('PayPal Error:', err);
  //               setStatus('fail');
  //             }
  //           }).render('#paypal-button-container');
  //           console.log("PayPal subscription buttons rendered successfully.");
  //         }
  //       } else if (paymentMethod === 'one-time') {
  //         await loadPayPalScript('capture'); // For one-time payments, use 'capture' intent
  //         const container = document.getElementById('paypal-one-time-button-container');
  //         if (container) {
  //           container.innerHTML = ''; // Clear previous buttons
  //           container.style.display = 'block'; // Show container
  //           window.paypal.Buttons({
  //             style: {
  //               shape: 'pill',
  //               color: 'blue',
  //               layout: 'vertical',
  //               label: 'pay',
  //             },
  //             createOrder: function (data, actions) {
  //               return actions.order.create({
  //                 purchase_units: [{
  //                   amount: {
  //                     value: amount,
  //                     currency_code: "USD"
  //                   },
  //                   description: `Membership Payment`
  //                 }]
  //               });
  //             },
  //             onApprove: async function (data, actions) {
  //               try {
  //                 const details = await actions.order.capture();
  //                 if (details.status === "COMPLETED") {
  //                   await handlePaymentSuccess(details.id, false);
  //                 } else {
  //                   setStatus('fail');
  //                 }
  //               } catch (error) {
  //                 console.error('Payment capture error:', error);
  //                 setStatus('fail');
  //               }
  //             },
  //             onCancel: function () {
  //               setStatus('cancel');
  //               console.log("PayPal one-time payment cancelled.");
  //             },
  //             onError: function (err) {
  //               console.error('PayPal Error:', err);
  //               setStatus('fail');
  //             }
  //           }).render('#paypal-one-time-button-container');
  //           console.log("PayPal one-time payment buttons rendered successfully.");
  //         }
  //       }
  //     } catch (e) {
  //       console.error("Error loading PayPal SDK or rendering buttons:", e);
  //       setStatus('fail');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   renderButtons();

  //   // Cleanup function
  //   return () => {
  //     const script = document.getElementById(scriptId);
  //     if (script) {
  //       script.remove();
  //       delete window.paypal; // Crucial to clear global object
  //       console.log("Cleanup: Removed PayPal SDK script and cleared window.paypal.");
  //     }
  //     // Also clear button containers on unmount or method change
  //     const subContainer = document.getElementById('paypal-button-container');
  //     const oneTimeContainer = document.getElementById('paypal-one-time-button-container');
  //     if (subContainer) subContainer.innerHTML = '';
  //     if (oneTimeContainer) oneTimeContainer.innerHTML = '';
  //   };
  // }, [paymentMethod, amount, userId]); // Re-run when paymentMethod changes


  useEffect(() => {
    if (!paymentMethod) return;
  
    const scriptId = 'paypal-sdk-script';
  
    const loadPayPalScript = (intent) => {
      return new Promise((resolve, reject) => {
        try {
          let existingScript = document.getElementById(scriptId);
          if (existingScript) {
            existingScript.remove();
            delete window.paypal;
            console.log("Removed existing PayPal SDK script and cleared window.paypal.");
          }
  
          const script = document.createElement('script');
          script.id = scriptId;
          //const scriptSrc = `https://www.paypal.com/sdk/js?client-id=AYB2yrW-VqMF7hAxqkXp4KZP-wLFomi24wBCLVQB3hna7V2mCdqZz4e4V3muCnlVw_6VcD4yhXQY0Rp8&vault=true&intent=${intent}`;
          const scriptSrc = `https://www.paypal.com/sdk/js?client-id=AdIC-dKALIhrIWWpcWxiuDFecByoYtS_rTHiTeugnaKvgjHll8JDVDbyRCutlaPYBtk2HeULvHKELome&vault=true&intent=${intent}`;
          script.src = scriptSrc;
          script.setAttribute('data-sdk-integration-source', 'button-factory');
          script.async = true;
          document.body.appendChild(script);
  
          script.onload = () => {
            const checkReady = setInterval(() => {
              if (window.paypal) {
                clearInterval(checkReady);
                console.log(`PayPal SDK loaded for intent: ${intent}.`);
                resolve();
              }
            }, 50);
          };
  
          script.onerror = (error) => {
            console.error("Failed to load PayPal SDK script:", error);
            reject(new Error("PayPal SDK script failed to load."));
          };
        } catch (error) {
          console.error("Exception while setting up PayPal script:", error);
          reject(error);
        }
      });
    };
  
    const renderButtons = async () => {
      try {
        setLoading(true);
        if (paymentMethod === 'subscription') {
          await loadPayPalScript('subscription');
          const container = document.getElementById('paypal-button-container');
          if (container) {
            container.innerHTML = '';
            container.style.display = 'block';
            window.paypal.Buttons({
              style: {
                shape: 'pill',
                color: 'gold',
                layout: 'vertical',
                label: 'subscribe',
              },
              createSubscription: function (data, actions) {
                return actions.subscription.create({
                  //plan_id: 'P-8EG07744WM7769432NBOKQKQ',
                  plan_id:'P-8EG07744WM7769432NBOKQKQ'
                });
              },
              onApprove: async function (data) {
                try {
                  if (data.subscriptionID) {
                    await handlePaymentSuccess(data.subscriptionID, true);
                  } else {
                    setStatus('fail');
                  }
                } catch (err) {
                  console.error("Error during subscription approval:", err);
                  setStatus('fail');
                }
              },
              onCancel: function () {
                setStatus('cancel');
                console.log("PayPal subscription cancelled.");
              },
              onError: function (err) {
                console.error('PayPal Error (subscription):', err);
                setStatus('fail');
              }
            }).render('#paypal-button-container');
            console.log("PayPal subscription buttons rendered successfully.");
          }
        } else if (paymentMethod === 'one-time') {
          await loadPayPalScript('capture');
          const container = document.getElementById('paypal-one-time-button-container');
          if (container) {
            container.innerHTML = '';
            container.style.display = 'block';
            window.paypal.Buttons({
              style: {
                shape: 'pill',
                color: 'blue',
                layout: 'vertical',
                label: 'pay',
              },
              createOrder: function (data, actions) {
                return actions.order.create({
                  purchase_units: [{
                    amount: {
                      value: amount,
                      currency_code: "USD"
                    },
                    description: `Membership Payment`
                  }]
                });
              },
              onApprove: async function (data, actions) {
                try {
                  const details = await actions.order.capture();
                  if (details.status === "COMPLETED") {
                    await handlePaymentSuccess(details.id, false);
                  } else {
                    setStatus('fail');
                  }
                } catch (error) {
                  console.error('Payment capture error:', error);
                  setStatus('fail');
                }
              },
              onCancel: function () {
                setStatus('cancel');
                console.log("PayPal one-time payment cancelled.");
              },
              onError: function (err) {
                console.error('PayPal Error (one-time):', err);
                setStatus('fail');
              }
            }).render('#paypal-one-time-button-container');
            console.log("PayPal one-time payment buttons rendered successfully.");
          }
        }
      } catch (e) {
        console.error("Error rendering PayPal buttons:", e);
        setStatus('fail');
      } finally {
        setLoading(false);
      }
    };
  
    renderButtons();
  
    return () => {
      try {
        const script = document.getElementById(scriptId);
        if (script) {
          script.remove();
          delete window.paypal;
          console.log("Cleanup: Removed PayPal SDK script and cleared window.paypal.");
        }
  
        const subContainer = document.getElementById('paypal-button-container');
        const oneTimeContainer = document.getElementById('paypal-one-time-button-container');
        if (subContainer) subContainer.innerHTML = '';
        if (oneTimeContainer) oneTimeContainer.innerHTML = '';
      } catch (cleanupError) {
        console.error("Error during PayPal cleanup:", cleanupError);
      }
    };
  }, [paymentMethod, amount, userId]);

  

  // useEffect(() => {
  //   let timer;
  //   if (status === 'success' && countdown > 0) {
  //     timer = setInterval(() => {
  //       setCountdown((prevCount) => prevCount - 1);
  //     }, 1000);
  //   } else if (status === 'success' && countdown === 0) {
  //     navigate('/login');
  //   }
  //   return () => clearInterval(timer);
  // }, [status, countdown, navigate]);


  useEffect(() => {
    let timer;
    try {
      if (status === 'success' && countdown > 0) {
        timer = setInterval(() => {
          try {
            setCountdown((prevCount) => prevCount - 1);
          } catch (err) {
            console.error('Error updating countdown:', err);
            clearInterval(timer);
          }
        }, 1000);
      } else if (status === 'success' && countdown === 0) {
        try {
          navigate('/login');
        } catch (err) {
          console.error('Navigation error:', err);
        }
      }
    } catch (error) {
      console.error('Unexpected error in countdown effect:', error);
    }
  
    return () => clearInterval(timer);
  }, [status, countdown, navigate]);
  


  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4 font-inter">
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Complete Your Payment</h2>

        <Modal show={!paymentMethod} backdrop="static" centered>
          <Modal.Header>
            <Modal.Title>Select Payment Method</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <p>Please choose how you'd like to proceed:</p>
            <div className="d-flex justify-content-around">
              {/* <Button variant="success" onClick={() => setPaymentMethod('subscription')}>
                Subscribe
              </Button>
              <Button variant="primary" onClick={() => setPaymentMethod('one-time')}>
                One-Time Payment
              </Button> */}
              {membershipType === '2' ? (
                <>
                  <Button variant="success" onClick={() => setPaymentMethod('subscription')}>
                    Subscribe
                  </Button>
                  <Button variant="primary" onClick={() => setPaymentMethod('one-time')}>
                    One-Time Payment
                  </Button>
                </>
              ) : (
                <Button variant="primary" onClick={() => setPaymentMethod('one-time')}>
                  One-Time Payment
                </Button>)}
            </div>
          </Modal.Body>
        </Modal>

        {loading && paymentMethod && ( // Only show loading when a method is chosen and loading is true
          <div className="text-blue-600 text-lg mb-4">
            Loading PayPal {paymentMethod === 'subscription' ? 'subscription' : 'one-time payment'} buttons...
          </div>
        )}

        {paymentMethod && (
          <p className="text-gray-700 mb-4">
            <strong>Selected Method:</strong> {paymentMethod === 'subscription' ? 'Subscription' : 'One-Time Payment'}
          </p>
        )}

        {/* These divs will be populated by PayPal buttons */}
        <div id="paypal-button-container" className="mb-6" style={{ display: paymentMethod === 'subscription' ? 'block' : 'none' }}></div>
        <div id="paypal-one-time-button-container" className="mb-6" style={{ display: paymentMethod === 'one-time' ? 'block' : 'none' }}></div>


        {status === 'success' && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-md relative mb-4">
            <strong className="font-bold">✅ Payment Successful!</strong>
            <span className="block sm:inline"> Your {paymentMethod === 'subscription' ? 'subscription' : 'payment'} is now active.</span>
            {(subscriptionID || transactionID) && (
              <p className="text-sm mt-2">
                {paymentMethod === 'subscription' ? 'Subscription' : 'Transaction'} ID:
                <code className="font-mono bg-green-200 p-1 rounded ml-1">
                  {paymentMethod === 'subscription' ? subscriptionID : transactionID}
                </code>
              </p>
            )}
            <p className="text-sm mt-2">Redirecting to login in {countdown} seconds...</p>
          </div>
        )}

        {status === 'fail' && (
          <div className="bg-red-100 text-red-700 p-4 rounded-lg font-semibold flex items-center justify-center gap-2">
            <span className="text-2xl">❌</span> Payment Failed. Please try again.
          </div>
        )}

        {status === 'cancel' && (
          <div className="bg-orange-100 text-orange-700 p-4 rounded-lg font-semibold flex items-center justify-center gap-2">
            <span className="text-2xl">⚠️</span> Payment was cancelled by the user.
          </div>
        )}
      </div>
    </div>
  );
}

export default PaymentPage;